/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { Link } from "react-router-dom";
import cn from "clsx";
import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap/index";
import { ReactComponent as ChevronLeft } from "assets/images/icons/common/chevron-left.svg";
import { ReactComponent as ChevronRight } from "assets/images/icons/common/chevron-right.svg";

const HeroSlide = (props) => {
    const images = props?.images;
    const slides = props?.slides;
    const index = props?.index;
    const total = props?.total;
    const moveIndex = props?.moveIndex;
    const image_position = "background";
    const slide = slides[index];
    const title = slide?.title;
    const description = slide?.description;
    const link = slide?.link;
    const text = link?.text;
    const link_url = link?.url;
    const image = Array.isArray(images) && images[index];
    const { src, alt } = image || {};

    const showControls = slides.length > 1;
    const controlsClassName = cn("forward-back", { "hide": !showControls });

    const goToPreviousSlide = () => {
        moveIndex(-1);
    };
    const goToNextSlide = () => {
        moveIndex(1);
    };

    if (image_position === "background") {
        return (
            <div
                className='hero-slide'
                title={alt}
                style={{
                    backgroundImage: `url(${src})`
                }}
            >
                <div className='hero-content-container'>
                    <div className='hero-content'>

                        <h1>
                            {title}
                            {subtitle && <span>{` ${subtitle}`}</span>}
                        </h1>

                        <RichTextPreview
                            richtext={description}
                            className='hero-slide-description'
                        />
                        <Link to={link_url} className='hero-slide-link'>
                            {text}
                        </Link>
                    </div>

                    <div className='hero-controls'>

                        <div className={controlsClassName}>

                            <button aria-label='Previous' onClick={goToPreviousSlide}>
                                <ChevronLeft />
                            </button>

                            <span>{`${index + 1}/${total}`}</span>

                            <button aria-label='Next' onClick={goToNextSlide}>
                                <ChevronRight />
                            </button>

                        </div>
                    </div>
                </div>

            </div>
        );
    }

    // For left/right image positioning
    const isImageLeft = image_position === "left";
    const isImageRight = image_position === "right";

    return (
        <div className='hero-slide' title={alt}>
            <div className='hero-slider-wrapper'>
                <div className='hero-slider-content-container'>
                    {isImageLeft && <div className='hero-left-container'>
                        <img src={src} alt={alt} />
                    </div>}
                
                    <div className='hero-content'>
                        <h3>
                            {title}
                            {subtitle && <span>{` ${subtitle}`}</span>}
                        </h3>

                        <RichTextPreview
                            richtext={description}
                            className='hero-slide-description'
                        />
                        <Link to={link_url} className='hero-slide-link'>
                            {text}
                        </Link>
                    </div>

                    {isImageRight && <div className='hero-left-container'>
                        <img src={src} alt={alt} />
                    </div>}
                </div>

                <div className='hero-left-right-controls'>
                    <div className={controlsClassName}>
                        <button aria-label='Previous' onClick={goToPreviousSlide}>
                            <ChevronLeft />
                        </button>

                        <div>{`${index + 1}/${total}`}</div>

                        <button aria-label='Next' onClick={goToNextSlide}>
                            <ChevronRight />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
export { HeroSlide };
